import * as actionTypes from './types';

const INTIAL_STATE = {
    predictions: {},
    placeDetails: {},
};

function setPredictions(state, action) {
    const {
        meta: id,
        payload: predictions,
    } = action;

    return {
        ...state,
        predictions: {
            ...state.predictions,
            [id]: [...predictions],
        },
    };
}

function setPlaceDetails(state, action) {
    const {
        meta: id,
        payload: placeDetails,
    } = action;

    return {
        ...state,
        placeDetails: {
            ...state.placeDetails,
            [id]: {
                ...placeDetails,
            },
        },
    };
}

const reducerFunctions = {
    [actionTypes.SET_PREDICTIONS]: setPredictions,
    [actionTypes.SET_PLACE_DETAILS]: setPlaceDetails,
};

export default function reducer(state = INTIAL_STATE, action) {
    if (!reducerFunctions.hasOwnProperty(action.type)) {
        return state;
    }

    return reducerFunctions[action.type](state, action);
}
